import React from 'react';

const kvBadgeTones={
  neutral:{background:'var(--ink-100)',color:'var(--ink-700)'},
  brand:{background:'var(--surface-brand-soft)',color:'var(--burgundy-800)'},
  solid:{background:'var(--surface-brand)',color:'var(--white)'},
  success:{background:'var(--status-success-bg)',color:'var(--status-success-fg)'},
  warning:{background:'var(--status-warning-bg)',color:'var(--status-warning-fg)'},
  danger:{background:'var(--status-danger-bg)',color:'var(--status-danger-fg)'},
  info:{background:'var(--status-info-bg)',color:'var(--status-info-fg)'}
};

export function Badge({tone='neutral',dot=false,style,children,...rest}){
  const s={display:'inline-flex',alignItems:'center',gap:'var(--space-2)',height:22,padding:'0 var(--space-3)',borderRadius:'var(--radius-pill)',fontFamily:'var(--font-text)',fontSize:'var(--fs-2xs)',fontWeight:'var(--fw-medium)',lineHeight:1,whiteSpace:'nowrap',...kvBadgeTones[tone],...style};
  return React.createElement('span',{style:s,...rest},
    dot?React.createElement('span',{style:{width:6,height:6,borderRadius:'999px',background:'currentColor'}}):null,
    children);
}
